import React from 'react'

import Chip from '@material-ui/core/Chip'

import ErrorIcon from '@material-ui/icons/Error'

import DashboardCard from '../../@react-fefmwk/cards/modules/DashboardCard'
import Table from '../../@react-fefmwk/tables/modules/Table'
import { EntitySchema } from '../../services/EntitySchema'
import { tableSchema } from '../../services/EntityTableSchema'
import { actionSchema } from '../../services/EntityRowActionsSchema'
import { activities_get_reports } from '../../services/BE'

class WidgetTaskReports extends React.Component {
    constructor(props) {
        super(props)

        const entity = "reports"
        const entityObj = EntitySchema[entity]
        const id_field = entityObj.id_field

        this.state = {
            entity: entity,
            id_field: id_field,
            path: this.props.path,
            id_activity: this.props.id_activity,
            reports: [],
        }
    }
    
    async getReports() {
        const id_activity = this.props.id_activity
        const fields = this.props.hasOwnProperty('fields') ? this.props.fields : ''
        this.setState({
            reports: await activities_get_reports( id_activity,fields ),
        })
    }
    
    async componentDidMount() {
        this.getReports()
    }

    async componentDidUpdate(prevProps) {
        const id_activity = this.props.id_activity
        if( id_activity !== prevProps.id_activity )
            this.getReports()
    }

    render() {
        const id_activity = this.props.id_activity
        const entity = this.state.entity
        const id_field = this.state.id_field
        const reports = this.state.reports
        const fieldsProps = tableSchema(entity)

        const tableRowActions = this.props.hasOwnProperty('tableRowActions')
            ? this.props.tableRowActions
            : true
        const rowActions = tableRowActions
            ? actionSchema(entity)
            : {}

        const dashboardcardTitle = this.props.dashboardcardTitle
            ? this.props.dashboardcardTitle
            : "Report"
        const noTitle = this.props.hasOwnProperty('noTitle')
        const noCard = this.props.hasOwnProperty('noCard')
        const cardProps = {
            ...{title: dashboardcardTitle},
            ...noTitle ? {noTitle: true} : {},
            ...noCard ? {noCard: true} : {},
        }

        return <DashboardCard {...cardProps}
            Content={reports.length
                ? <Table material highlight dense
                    data={reports}
                    fieldsProps={fieldsProps}
                    rowActions={rowActions}
                    rowActionsField={id_field}
                    showPagination={true}
                    sortable={true}
                    filterable={false}
                />
                : <Chip icon={<ErrorIcon />} label="Nessuna report trovato" variant="outlined" />}
        />
    }
}

export default WidgetTaskReports